import {Component, Input, OnInit} from '@angular/core';
import { SupportContact } from '../../../domain/operator/frontEndConfig';
import { SupportContactContext } from '../../../domain/operator/frontEndConfig';
import {ModalControllerService} from '../../../services/common/modalController.service';
import {IziviaPlatformService} from '../../../services/common/iziviaPlatform.service';
import {NavController} from '@ionic/angular';
import {ModalWithBackButtonDirective} from '../../modals/modalWithBackButton.directive';

@Component({
    selector: 'support-contact',
    templateUrl: './supportContact.component.html',
    styleUrls: ['./supportContact.component.scss']
})
export class SupportContactComponent extends ModalWithBackButtonDirective implements OnInit {

    @Input() supportContact: SupportContact;
    @Input() supportContactContext?: SupportContactContext;

    mailTo: string;

    constructor(readonly modalControllerService: ModalControllerService,
        readonly platformService: IziviaPlatformService,
        readonly navController: NavController) {
        super(modalControllerService, navController, platformService);
    }

    ngOnInit(): void {
        super.ngOnInit();

        if (this.supportContact?.mail) {
            this.mailTo = `mailto:${this.supportContact.mail}?`;


            if (this.supportContactContext?.mailSubject) {
                this.mailTo += `subject=${encodeURI(this.supportContactContext.mailSubject)}&`;
            }

            if (this.supportContactContext?.mailBody) {
                this.mailTo += `body=${encodeURI(this.supportContactContext.mailBody)}`;
            }

        }
    }
}
